/**
 * @file HTTP 请求统一处理
 * @author cuibolun<cuibolun@baijia.com>
 * @date 2021-03-04
 */
import axios from 'axios';
import constant from './constant';

/* eslint-disable no-magic-numbers */
const defaultEnvType = 'local';
const envType = defaultEnvType;

//
// const baseURL = envType === defaultEnvType ? 'https://api.baijia.com/mock/2523' : '';
const baseURL = envType === defaultEnvType ? '' : '';

const HttpCode = {
    // 请求成功
    ok: 200,
    // Not Modified
    NOT_MODIFIED: 304,
    // 操作成功
    success: 0,
    // 操作失败
    error: 1,
    // 无权限
    NO_AUTH: 403,
    // 参数异常
    paramsError: 411,
    // 业务错误
    businessError: 400,
    // 请登录
    NEED_LOGIN: 700,
    // 资源不存在
    notFound: 404,
    // 服务端错误,
    serverError: 500,
};

const instance = axios.create({
    baseURL,
    timeout: 5000,
});

/**
 * 添加一个请求拦截器
 * 处理一下导出接口的请求
 */
instance.interceptors.request.use(
    (config: any) => {
        // config.url = `${config.url}`;
        config.url = `/api${config.url}`;
        return config;
    },
    error => Promise.reject(error)
);

const success = (response: any) => {
    const {data} = response;
    const {location, code, msg} = data;

    if (code && code === HttpCode.NEED_LOGIN) {
        const splitStr = encodeURIComponent(origin);
        const index = location.indexOf(splitStr);
        const newStr = location.slice(0, index);
        const replaceStr = encodeURIComponent('/ferry-admin/index.json&renew=true');
        const newLocation = `${newStr}${splitStr}${replaceStr}`;
        window.location.href = newLocation;
    }
    else if (code && code !== HttpCode.ok) {
        // 针对返回的异常情况统一处理
        return Promise.reject(msg);
    }
    else {
        return data;
    }
};

const msg = '网络异常，请稍后重试';

const fail = (error: any) => {
    const {response} = error;
    if (response?.status && response?.status === HttpCode.NO_AUTH) {
        window.location.href = `${window.location.origin}${constant.USER.GET_USER_INFO}`;
        return null;
    }
    return Promise.reject(msg);
};

instance.interceptors.response.use(success, fail);
// @ts-ignore
instance.axios = axios;

export default instance;
